<template>
	<div>
		<div v-if="!list">
			<v-btn small @click="doAction('download')" class="mx-0 mt-0" flat>
				<div class="v-icon v-icon--left">
					<fa-icon
						icon="file-word"
						class="primary--text text--darken-2"
						size="xs"
					/>
				</div>
				Download {{ doc_type }}
			</v-btn>

			<v-btn small @click="doAction('print')" class="mx-0 mt-0" flat>
				<div class="v-icon v-icon--left">
					<fa-icon icon="print" size="xs" />
				</div>
				Print {{ doc_type }}
			</v-btn>

			<v-btn small @click="save" class="mx-0 mt-0" flat>
				<div class="v-icon v-icon--left">
					<fa-icon icon="save" size="xs" />
				</div>
				Save & Close
			</v-btn>
		</div>
		<v-list v-else>
			<v-list-tile ripple @click="doAction('send')">
				<v-list-tile-action>
					<div class="v-icon v-icon--left">
						<fa-icon
							:icon="['far', 'paper-plane']"
							size="sm"
							fixed-width
						/>
					</div>
				</v-list-tile-action>

				<v-list-tile-content>
					<v-list-tile-title>Attach & Send</v-list-tile-title>
				</v-list-tile-content>
			</v-list-tile>

			<v-list-tile ripple @click="doAction('preview')">
				<v-list-tile-action>
					<div class="v-icon v-icon--left">
						<fa-icon
							:icon="['far', 'file-search']"
							size="sm"
							fixed-width
						/>
					</div>
				</v-list-tile-action>

				<v-list-tile-content>
					<v-list-tile-title
						>Preview {{ doc_type }}</v-list-tile-title
					>
				</v-list-tile-content>
			</v-list-tile>
		</v-list>
		<!-- <code>{{document}}</code> -->
	</div>
</template>

<script>
import { mapActions } from "vuex";
import { log } from "util";
var { quoteBuilder } = require("@root/mixins");

export default {
	mixins: [quoteBuilder],

	data() {
		return {};
	},

	props: {
		list: {
			default: false
		}
	},

	computed: {
		isQuote() {
			return this.document.saved_at === null;
		},

		isOrder() {
			return this.document.ordered_at !== null;
		},

		doc_type() {
			return this.isOrder ? "Order" : "Quote";
		}
	},

	methods: {
		...mapActions("documents", {
			SEND_DOCUMENT: "sendDocument",
			SAVE_DOCUMENT: "saveDocument"
		}),

		doAction(action) {
			if (this.document.for_customer) {
				let customerPrice = this.document.show_customer_price
					? " and add configured End User Price"
					: "";
				this.$swal({
					title: "Which Version?",
					text: `Would you like an End User version or an Internal version? End Users Quotes have Net Pricing removed${customerPrice}.`,
					type: "question",
					showCloseButton: true,
					showCancelButton: true,
					confirmButtonText: "Internal",
					cancelButtonText: "End User"
				}).then(result => {
					if (result.value) {
						this[action].call(this, true);
					} else if (
						result.dismiss === this.$swal.DismissReason.cancel
					) {
						let internal = false;
						this[action].call(this, false);
					}
				});
			} else {
				this[action].call(this, true);
			}
		},

		url(uri, query_string = "") {
			if (query_string !== "") {
				query_string = `?${query_string}`;
			}
			return `/documents/${this.document.number}/${uri}${query_string}`;
		},

		download(internal) {
			window.open(this.url("download", `internal=${internal}`));
		},

		print(internal) {
			window.open(this.url("pdf", `internal=${internal}`));
		},

		save() {
			this.$router.push("/quotes");
		},

		preview(internal) {
			this.$swal({
				titleText: `Preview Quote: ${this.document.name}`,
				html: `
					<div id="modal-overlay" class="iframe-loader"></div>
					<iframe src="${this.url("pdf", `preview=true&internal=${internal}`)}",
							height="600px" width="100%" frameborder="0"
							onload="document.getElementById('modal-overlay').classList.add('hidden')"
					></iframe>
					`,
				width: "800px",
				padding: "0",
				customClass: "proposal-preview",
				showConfirmButton: false,
				showCloseButton: true
			});
		},

		send(internal) {
			this.SEND_DOCUMENT({ number: this.document.number, internal }).then(
				data => {
					// console.log(data);
					if (data !== undefined) {
						// this.nextStep(6);
					}
				}
			);
		}
	}
};
</script>

<style lang="scss" scoped>
.v-list__tile__action {
	min-width: auto;
}
</style>
